import { decode } from 'html-entities'

/**
 * Recursively decodes all string values in a JSON object.
 * @param data - The parsed JSON object or array
 * @returns A new object or array with all strings decoded
 */
export const decodeAllStrings = (data: any): any => {
  if (typeof data === 'string') {
    return decode(data)
  } else if (Array.isArray(data)) {
    return data.map(decodeAllStrings) // Recursively decode array elements
  } else if (typeof data === 'object' && data !== null) {
    return Object.keys(data).reduce(
      (acc, key) => {
        acc[key] = decodeAllStrings(data[key]) // Recursively decode object properties
        return acc
      },
      {} as Record<string, any>
    )
  }
  return data // Return other types (numbers, booleans) as-is
}
